export default __webpack_public_path__ + "static/media/Group 10499.4a68e224.png";